<template>
	<div class="council">
		<div class="council_cont">
			<div class="crumbs">当前位置：论坛首页-论坛理事会</div>
			<div class="council_list">
				<div class="list" v-for="(item,index) in zhuanjia">
					<router-link :to="{path:'/council_details',query:{id:item.id,u:item.updateTime,exp_id:item.id}}" class="listx">
						<div class="ment">
							<div class="photo">
								<img :src="item.avator" alt="">
							</div>
							<div class="name">{{item.name}}</div>
							<div class="text">{{item.title}}</div>
						</div>
					</router-link>
				</div>
			</div>
			<el-pagination
			  background
			  layout="prev, pager, next"
			  :total="total"
			  :page-size="tablePage.pageSize"
			  :current-page="tablePage.pageNum"
			  @size-change="handleSizeChange"
			  @current-change="handlePageChange"
			  >
			</el-pagination>

			<div class="secretariat">
				<div class="secretariat_title">理事会秘书处</div>
				<div class="secretariat_list">
					<div class="secretariat_item" v-for="(item, index) in secretariatMembers" :key="index">
						<div class="secretariat_photo" :class="{ 'is-placeholder': !item.avatar }">
							<img v-if="item.avatar" :src="item.avatar" :alt="item.name">
							<span v-else>无头像</span>
						</div>
						<div class="secretariat_info">
							<div class="secretariat_name">{{ item.name }}</div>
							<div class="secretariat_role">{{ item.role }}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {encrypt,decrypt, generatekey,} from "@/plugins/des2.js"
	import {ExpertAllList} from '../../api/api.js'
	import qs from 'qs'
	export default {
		name: 'council',
		data() {
			return {
				zhuanjia:[],
				tablePage: {
					pageNum: 1, // 第几页
					pageSize: 20, // 每页多少条
				},
				zhuanjiaall:[],
				total:1,
				secretariatMembers: [
					{
						name: '钱学宁',
						role: '中国首席经济学家论坛理事、秘书长',
						avatar: require('../../assets/qianxuening.jpg')
					},
					{
						name: '高园',
						role: '副秘书长，古宇集团董事长',
						avatar: require('../../assets/gaoyuan.jpg')
					}
				]
			}
		},
		mounted() {
			this.ExpertAllList()
		},
		methods:{
			handlePageChange(currentPage) {
			
			  this.tablePage.pageNum = currentPage
			  this.ExpertAllList()
			  // 在此刷新数据
			},
			handleSizeChange(pageSize) {
				
			  this.tablePage.pageSize = pageSize
			  // 在此刷新数据
			},
			async ExpertAllList(){
				//加密	
				const key = localStorage.getItem('key')// generatekey(8); // 也可直接指定固定key值 let key = 'des';  
				let time = parseInt(new Date().getTime() / 1000)
				let data={
				      	token: time+"&"+localStorage.getItem('token'),
				      	os: "Web",
				      	type:-1,
						page:this.tablePage.pageNum
					
				}
				      //如果是对象/数组的话，需要先JSON.stringify转换成字符串
				const encrypts = encrypt(JSON.stringify(data), key, key);
				let encrypts1 = encrypts.replace(/\//g,"@@");
				let encrypts2 = encrypts1.replace(/[+]/g,"$$$$");
				let requetp={
						p:encrypts2
				}	
				let res=await ExpertAllList(qs.stringify(requetp))	
				//解密
				let res1=res.data
				let encrypts3 = res1.replace(/@@/g, "/");
				let encrypts4 = encrypts3.replace(/\$\$/g, "+");
				const dess = decrypt(encrypts4,key,key);  	
				this.zhuanjia=JSON.parse(dess).d.Data
				this.total=JSON.parse(dess).d.Total
			},
			
		}
	}
</script>

<style>
	.el-pagination{
		text-align: center;
	}
	.council .crumbs {
		width: 1200px;
		margin: 0 auto;
		padding-top: 25px;
		font-size: 16px;
		color: #999999;
	}
	.photo img{
	width: 160px;
	    height: 160px;
	    border-radius: 50%;
	    object-fit: cover;
	}
	.council .council_cont {
		background-color: #fafafa;
		padding-bottom: 10px;
	}

	.council .council_list {
		width: 1230px;
		margin: 0 auto;
		margin-top: 30px;
		display: flex;
		flex-wrap: wrap;
	}

	.council .council_list .list {
		width: 23%;
		margin: 0 1%;
		background-color: #fff;
		margin-bottom: 15px;
	}

	.council .council_list .list .listx {
		text-decoration: none;
	}

	.council .council_list .list .ment {
		padding: 50px 25px 40px 25px;
	}

	.council .council_list .list .ment .photo {
		text-align: center;
		margin-bottom: 20px;
		margin-left: 5px;
	}

	.council .council_list .list .ment .name {
		color: #333333;
		font-size: 24px;
		text-align: center;
		font-weight: bold;
		margin-bottom: 15px;
		margin-left: 5px;
	}

	.council .council_list .list .ment .text {
		font-size: 16px;
		color: #666666;
		text-align: center;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
		margin-left: 5px;
		line-height: 25px;
	}

	.council .secretariat {
		width: 1160px;
		margin: 28px auto 30px;
		background: #f4f6f8;
		border: 1px solid #e8ecf0;
		border-radius: 8px;
		padding: 18px 24px;
	}

	.council .secretariat .secretariat_title {
		font-size: 20px;
		font-weight: 600;
		color: #4a4a4a;
		line-height: 28px;
	}

	.council .secretariat .secretariat_list {
		margin-top: 14px;
		display: flex;
		gap: 14px;
	}

	.council .secretariat .secretariat_item {
		flex: 1;
		min-width: 0;
		display: flex;
		align-items: center;
		background: #fff;
		border: 1px solid #edf1f5;
		border-radius: 8px;
		padding: 12px 14px;
	}

	.council .secretariat .secretariat_photo {
		width: 58px;
		height: 58px;
		border-radius: 50%;
		overflow: hidden;
		flex: 0 0 58px;
		margin-right: 12px;
		background: #eceff3;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #a3adb8;
		font-size: 12px;
	}

	.council .secretariat .secretariat_photo img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.council .secretariat .secretariat_photo.is-placeholder {
		border: 1px dashed #d2d8e0;
	}

	.council .secretariat .secretariat_name {
		font-size: 18px;
		font-weight: 600;
		color: #333;
		line-height: 24px;
	}

	.council .secretariat .secretariat_role {
		margin-top: 4px;
		font-size: 14px;
		color: #666;
		line-height: 22px;
	}

	@media screen and (max-width: 1400px){
		.council .crumbs {
		    width: 900px;
		    padding-top: 20px;
		    font-size: 16px;
		}
		.council .council_list {
		    width: 900px;
		    margin-top: 20px;
		}
		.council .secretariat {
			width: 900px;
		}
	}
	@media screen and (max-width: 1000px){
		.council .crumbs {
		    width: 750px;
		    margin-top: 10px;
		    font-size: 16px;
		}
		.council .council_list {
		    width: 750px;
		    margin-top: 10px;
		}
		.council .council_list .list .ment .photo img{
			width: 100%;
			height: 100%;
		}
		.council .council_list .list .ment {
		    padding: 15px;
		}
		.council .council_list .list .ment .photo {
		    text-align: center;
		    margin-bottom: 10px;
		    margin-left: 0;
		}
		.council .secretariat {
			width: 750px;
			padding: 16px;
		}
		.council .secretariat .secretariat_list {
			gap: 10px;
		}
		.council .secretariat .secretariat_item {
			padding: 10px 12px;
		}
	}
	@media screen and (max-width: 768px){
		.council{
			margin-top: 60px;
		}
		.council .crumbs {
		    width: 98%;
		    margin-top: 0px;
		    font-size: 14px;
		}
		.council .council_list {
		    width: 98%;
		    margin-top: 20px;
			justify-content: space-between;
		}
		.council .council_list .list {
		    width: 49%;
		    margin: 0 0%;
		    background-color: #fff;
		    margin-bottom: 15px;
		}
		.council .council_list .list .ment .name {
		    font-size: 18px;
		    margin-bottom: 5px;
		    margin-left: px;
		}
		.council .council_list .list .ment .text {
		    font-size: 14px;
		    color: #666666;
		    text-align: center;
		    display: -webkit-box;
		    -webkit-line-clamp: 2;
		    overflow: hidden;
		    margin-left: 0px;
		    line-height: 25px;
		}
		.council .secretariat {
			width: 98%;
			margin: 16px auto 20px;
			padding: 14px;
		}
		.council .secretariat .secretariat_title {
			font-size: 18px;
		}
		.council .secretariat .secretariat_desc {
			font-size: 13px;
		}
		.council .secretariat .secretariat_list {
			flex-direction: column;
		}
	}
</style>
